export default __webpack_public_path__ + "static/media/speed-point.22d24f2a.svg";